import React, {
  FC, PropsWithChildren, useEffect, useMemo, useRef,
} from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';

import TopBar, { TopBarMode } from './topbar';
import LoadingSpinner from './loading-spinner';
import './styles.scss';

export const getFormattedMetaTitle = (metaTitle: string | undefined) => {
  const prefix = 'StudyCash';

  if (!metaTitle) {
    return prefix;
  }

  return `${prefix} - ${metaTitle}`;
};

export interface LayoutComponentProps extends PropsWithChildren {
  topBarMode?: TopBarMode;
  metaTitle?: string;
  backTo?: string;
}

const LayoutComponent: FC<LayoutComponentProps> = (props) => {
  const {
    children,
    topBarMode,
    metaTitle,
    backTo,
  } = props;

  const wrapperRef = useRef(null);
  const applyHeight = () => {
    if (wrapperRef.current) {
      (wrapperRef.current as HTMLElement).style.height = `${window.innerHeight}px`;
    }
  };

  useEffect(() => {
    if (wrapperRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        try {
          applyHeight();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      });
      resizeObserver.observe(wrapperRef.current);
    }
  }, []);

  const formattedMetaTitle = useMemo(() => getFormattedMetaTitle(metaTitle), [metaTitle]);

  return (
    <>
      <Helmet>
        <title>{formattedMetaTitle}</title>
      </Helmet>
      <Box ref={wrapperRef} className="app-layout-wrapper" data-testid="app-layout-wrapper">
        <LoadingSpinner />
        <Box className="topbar-wrapper" data-testid="topbar-wrapper">
          <TopBar mode={topBarMode} pageName={metaTitle} backTo={backTo} />
        </Box>
        <Box className="wrapper" data-testid="content-wrapper">
          {children}
        </Box>
      </Box>
    </>
  );
};

export default LayoutComponent;
